/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateEmployeeGroupData
 */
export interface UpdateEmployeeGroupData {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeGroupData
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateEmployeeGroupData
     */
    position?: number;
}

/**
 * Check if a given object implements the UpdateEmployeeGroupData interface.
 */
export function instanceOfUpdateEmployeeGroupData(value: object): value is UpdateEmployeeGroupData {
    return true;
}

export function UpdateEmployeeGroupDataFromJSON(json: any): UpdateEmployeeGroupData {
    return UpdateEmployeeGroupDataFromJSONTyped(json, false);
}

export function UpdateEmployeeGroupDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEmployeeGroupData {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'position': json['position'] == null ? undefined : json['position'],
    };
}

  export function UpdateEmployeeGroupDataToJSON(json: any): UpdateEmployeeGroupData {
      return UpdateEmployeeGroupDataToJSONTyped(json, false);
  }

  export function UpdateEmployeeGroupDataToJSONTyped(value?: UpdateEmployeeGroupData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'position': value['position'],
    };
}

